// @ts-nocheck 830fb41f
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_comboboxinput'],
      sections: [addPanel.sections.getSections().developer.selectionSection],
    };
  },
};
